import IpubTextarea from './src/main'

/* istanbul ignore next */
IpubTextarea.install = function(Vue) {
  Vue.component(IpubTextarea.name, IpubTextarea)
}

export default IpubTextarea
